// B1.4: move-only from client.ts.
import { ApiClientCore, ApiError, buildQueryString } from './http/core';

export class FilesApi extends ApiClientCore {
  async getFileById(fileId: string): Promise<{ url: string; [key: string]: any }> {
    return this.get(`/api/v1/files/by-id/${fileId}`);
  }
  async uploadFile(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await this.authedFetch(`${this.baseURL}/api/v1/files/upload`, {
      method: 'POST',
      body: formData,
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new ApiError(response.status, errorData.detail || response.statusText, errorData);
    }
    return response.json();
  }
  // ─── Consumable Request Participants (Request Circle) ─────────────────────────
}
